export interface IUser {
  id: string;
  name: string;
  surname: string;
  email: string;
  last_seen?: string;
  status: string;
  role: string;
  legal?: boolean;
}

export enum UserTabsVariants {
  profile = 'profile',
  orders = 'orders',
  favourites = 'favourites',
  returns = 'returns',
}
